import * as React from 'react';
import { CartItem, ShoppingCartContext } from '@weddingspot/ws-core-components';
import { ItemsList } from './ItemsList';
import * as analytics from '@weddingspot/ws-analytics';


export const VenuesList = () => {
    const { items, removeItem } = React.useContext(ShoppingCartContext);

    const removeFromList = (id: string | number) => () => {
        analytics.logEvent(
            analytics.AnalyticsEvent.EVTNM_VENUE_REMOVE_FROM_CART,
            {
                source: 'checkout page',
                venueId: id
            });
        removeItem(id);
    };

    const makePoweredBySubtitle = (item: CartItem) => (item?.isDestination==false  ? null : <b>by Destination Weddings</b>);

    return <ItemsList items={items} name='venues' removeItem={removeFromList} additionalSubtitle={makePoweredBySubtitle} />;
};
